import { DataLayer } from '@dgx-pr-spa/shared/util';
import { CurrentPlan } from '@dgx-pr-spa/shared/util';

export class GACSPageLoad {
  constructor(private readonly currentPlan: CurrentPlan) {}

  get gaData(): DataLayer {
    const planNumber = this.currentPlan?.plan_number
      ? this.currentPlan.plan_number
      : undefined;

    const dataLayer: DataLayer = {
      event: 'PRAWS',
      eventPR: 'product-replacement-call-customer-services',
      pagename: 'product-replacement-call-customer-services',
      genericpagename: 'product-replacement-checkout',
      category: 'product-replacement',
      planNumber,
      PRGroup: 'aws',
    };

    return dataLayer;
  }
}

export class GA404PageLoad {
  get gaData(): DataLayer {
    const dataLayer: DataLayer = {
      event: 'PRAWS',
      eventPR: '404',
      pagename: '404',
      genericpagename: 'product-replacement-checkout',
      category: 'product-replacement',
    };

    return dataLayer;
  }
}
